module.exports = __webpack_public_path__ + "img/icon-nav1.9afacba1.png";